import { RouteLocationNormalized } from "vue-router";
import { userResolver } from "./user.resolver";
import { rolesResolver } from "./roles.resolver";

export const userWithRolesResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        await Promise.all([userResolver(to, from), rolesResolver(to, from)]);
    } catch (error) {
        console.error('CONSENT_VERSION_RESTORE_RESOLVER_ERROR');
        return { name: 'Consents' };
    }
}